import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import LoadingArea from '~/components/LoadingArea';
import Sidebar from '~/components/Sidebar';

import Details from './Details';
import Events from './Events';
import Header from './Header';
import styles from './index.style';
import Pageviews from './Pageviews';

class ShowPerson extends React.Component {
  componentDidMount() {
    const { personId, fetchPerson } = this.props;

    if (!personId) return;

    setTimeout(() => {
      fetchPerson(personId);
    }, 200);
  }

  componentDidUpdate(prevProps) {
    const { personId, fetchPerson } = this.props;

    if (!personId) return;

    if (personId !== prevProps.personId) {
      fetchPerson(personId);
    }
  }

  render() {
    const { person, classes } = this.props;
    const hash = window.location.hash || '#';

    return (
      <Sidebar className={classes.sidebar}>
        <LoadingArea loading={!person}>
          {person && (
            <>
              <Header person={person} />

              <Helmet>
                <title>{person.name || person.email}</title>
              </Helmet>

              <Tabs className={classes.tabs} value={hash}>
                <Tab value="#" label="Details" to="#" component={Link} />
                <Tab
                  value="#pageviews"
                  label="Pageviews"
                  to="#pageviews"
                  component={Link}
                />
                <Tab
                  value="#events"
                  label="Events"
                  to="#events"
                  component={Link}
                />
              </Tabs>

              {(() => {
                switch (hash) {
                  case '#events':
                    return (
                      <Events className={classes.events} person={person} />
                    );
                  case '#pageviews':
                    return <Pageviews person={person} />;
                  default:
                    return <Details person={person} />;
                }
              })()}
            </>
          )}
        </LoadingArea>
      </Sidebar>
    );
  }
}

ShowPerson.propTypes = {
  person: PropTypes.object,
  classes: PropTypes.object.isRequired,
  fetchPerson: PropTypes.func.isRequired,
  personId: PropTypes.string,
};

export default withStyles(styles)(ShowPerson);
